import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PracticeAreas } from '../components/PracticeAreas';
import { ClipboardCheckIcon, UsersIcon, PresentationIcon, FileCheckIcon, ArrowRightIcon } from 'lucide-react';
export function PracticeAreasPage() {
  return <div className="w-full pt-20 lg:pt-24" data-id="element-437">
      {/* Page Header */}
      <div className="bg-navy py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-438">
        <div className="max-w-7xl mx-auto" data-id="element-439">
          <div className="font-sans text-sm font-semibold text-white/50 uppercase tracking-wider mb-4" data-id="element-440">
            <Link to="/" className="hover:text-gold transition-colors" data-id="element-441">
              Home
            </Link>
            <span className="mx-2 text-gold/50" data-id="element-442">/</span>
            <span className="text-gold" data-id="element-443">Practice Areas</span>
          </div>
          <h1 className="font-serif text-4xl md:text-6xl text-white font-bold" data-id="element-444">
            Our Practice Areas
          </h1>
          <div className="h-1 w-24 bg-gold mt-6" data-id="element-445"></div>
        </div>
      </div>

      {/* Practice Areas Component */}
      <PracticeAreas data-id="element-446" />

      {/* Our Engagement Process */}
      <section className="py-20 bg-cream-dark px-4 sm:px-6 lg:px-8" data-id="element-447">
        <div className="max-w-7xl mx-auto" data-id="element-448">
          <div className="text-center mb-16" data-id="element-449">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-450">
              How We Work
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-4" data-id="element-451">
              Our Engagement Process
            </h2>
            <p className="font-sans text-lg text-text-muted max-w-2xl mx-auto" data-id="element-452">
              Every client engagement is structured to deliver maximum value
              through a clear, transparent process.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-453">
            <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4
          }} data-id="element-454">
              <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-455">
                <ClipboardCheckIcon className="h-7 w-7 text-navy" strokeWidth={1.5} data-id="element-456" />
              </div>
              <div className="font-sans text-xs font-bold text-gold uppercase tracking-widest mb-3" data-id="element-457">
                Step 1
              </div>
              <h3 className="font-serif text-lg text-navy font-semibold mb-3" data-id="element-458">
                Scoping Call
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed" data-id="element-459">
                A 60-minute consultation to understand your objectives,
                timeline, and specific challenges in the region.
              </p>
            </motion.div>

            <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1
          }} data-id="element-460">
              <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-461">
                <UsersIcon className="h-7 w-7 text-navy" strokeWidth={1.5} data-id="element-462" />
              </div>
              <div className="font-sans text-xs font-bold text-gold uppercase tracking-widest mb-3" data-id="element-463">
                Step 2
              </div>
              <h3 className="font-serif text-lg text-navy font-semibold mb-3" data-id="element-464">
                Team Assembly
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed" data-id="element-465">
                We assemble a dedicated team of analysts and local partners
                tailored to your sector and target market.
              </p>
            </motion.div>

            <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.2
          }} data-id="element-466">
              <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-467">
                <PresentationIcon className="h-7 w-7 text-navy" strokeWidth={1.5} data-id="element-468" />
              </div>
              <div className="font-sans text-xs font-bold text-gold uppercase tracking-widest mb-3" data-id="element-469">
                Step 3
              </div>
              <h3 className="font-serif text-lg text-navy font-semibold mb-3" data-id="element-470">
                Strategy Delivery
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed" data-id="element-471">
                Comprehensive deliverables including policy briefs, stakeholder
                maps, and actionable strategic recommendations.
              </p>
            </motion.div>

            <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} data-id="element-472">
              <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-473">
                <FileCheckIcon className="h-7 w-7 text-navy" strokeWidth={1.5} data-id="element-474" />
              </div>
              <div className="font-sans text-xs font-bold text-gold uppercase tracking-widest mb-3" data-id="element-475">
                Step 4
              </div>
              <h3 className="font-serif text-lg text-navy font-semibold mb-3" data-id="element-476">
                Ongoing Advisory
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed" data-id="element-477">
                Continued support with quarterly reviews, regulatory monitoring,
                and strategic pivots as the landscape evolves.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Case Studies Preview */}
      <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-478">
        <div className="max-w-7xl mx-auto" data-id="element-479">
          <div className="text-center mb-16" data-id="element-480">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-481">
              Results
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6" data-id="element-482">
              Selected Engagements
            </h2>
            <div className="h-1 w-24 bg-gold mx-auto" data-id="element-483"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-484">
            <div className="bg-white rounded-card shadow-sm border border-cream-dark overflow-hidden group cursor-pointer hover:shadow-md transition-shadow" data-id="element-485">
              <div className="h-48 bg-navy/5 flex items-center justify-center" data-id="element-486">
                <span className="font-serif text-6xl text-navy/10 font-bold" data-id="element-487">
                  01
                </span>
              </div>
              <div className="p-8" data-id="element-488">
                <span className="font-sans text-xs font-bold text-gold uppercase tracking-widest" data-id="element-489">
                  Public Policy
                </span>
                <h3 className="font-serif text-xl text-navy font-semibold mt-3 mb-4" data-id="element-490">
                  <span className="gold-underline" data-id="element-491">
                    US Energy Firm's Nigerian Market Entry
                  </span>
                </h3>
                <p className="font-sans text-text-muted leading-relaxed mb-4" data-id="element-492">
                  Guided a Fortune 500 energy company through Nigeria's
                  regulatory framework for renewable energy investments,
                  securing all necessary approvals within 8 months.
                </p>
                <div className="flex items-center gap-6 pt-4 border-t border-gray-100" data-id="element-493">
                  <div data-id="element-494">
                    <div className="font-serif text-2xl text-navy font-bold" data-id="element-495">
                      $340M
                    </div>
                    <div className="font-sans text-xs text-gray-500" data-id="element-496">
                      Investment Facilitated
                    </div>
                  </div>
                  <div data-id="element-497">
                    <div className="font-serif text-2xl text-navy font-bold" data-id="element-498">
                      8 mo
                    </div>
                    <div className="font-sans text-xs text-gray-500" data-id="element-499">
                      Time to Approval
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-card shadow-sm border border-cream-dark overflow-hidden group cursor-pointer hover:shadow-md transition-shadow" data-id="element-500">
              <div className="h-48 bg-navy/5 flex items-center justify-center" data-id="element-501">
                <span className="font-serif text-6xl text-navy/10 font-bold" data-id="element-502">
                  02
                </span>
              </div>
              <div className="p-8" data-id="element-503">
                <span className="font-sans text-xs font-bold text-gold uppercase tracking-widest" data-id="element-504">
                  Monitoring & Evaluation
                </span>
                <h3 className="font-serif text-xl text-navy font-semibold mt-3 mb-4" data-id="element-505">
                  <span className="gold-underline" data-id="element-506">
                    USAID Health Program Evaluation in Ghana
                  </span>
                </h3>
                <p className="font-sans text-text-muted leading-relaxed mb-4" data-id="element-507">
                  Designed and implemented a comprehensive M&E framework for a
                  $50M maternal health initiative across 6 Ghanaian regions,
                  tracking 42 KPIs.
                </p>
                <div className="flex items-center gap-6 pt-4 border-t border-gray-100" data-id="element-508">
                  <div data-id="element-509">
                    <div className="font-serif text-2xl text-navy font-bold" data-id="element-510">
                      6
                    </div>
                    <div className="font-sans text-xs text-gray-500" data-id="element-511">
                      Regions Covered
                    </div>
                  </div>
                  <div data-id="element-512">
                    <div className="font-serif text-2xl text-navy font-bold" data-id="element-513">
                      42
                    </div>
                    <div className="font-sans text-xs text-gray-500" data-id="element-514">
                      KPIs Tracked
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-navy text-white text-center px-4 sm:px-6 lg:px-8" data-id="element-515">
        <div className="max-w-3xl mx-auto" data-id="element-516">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8" data-id="element-517">
            Ready to explore market opportunities?
          </h2>
          <p className="font-sans text-lg text-white/80 mb-10" data-id="element-518">
            Contact our advisory team to discuss how our expertise can support
            your strategic objectives in Nigeria and Ghana.
          </p>
          <Link to="/inquiry" className="inline-block bg-gold hover:bg-gold-light text-navy font-sans font-bold text-sm uppercase tracking-wide px-8 py-4 rounded-card transition-colors shadow-lg" data-id="element-519">
            Schedule a Consultation
          </Link>
        </div>
      </section>
    </div>;
}